import gql from 'graphql-tag'

export const fetchContactsList = () => {
	return {
		query: gql`
			{
				contacts: contacts(order_by: { name: asc }) {
					id
					name
					position
					email
					phone
					active
				}
			}
		`,
		update: data =>
			data.contacts.map(item => ({
				id: item.id,
				name: item.name,
				position: item.position,
				email: item.email,
				phone: item.phone,
				edit: true,
				active: item.active
			}))
	}
}
